// Action Types
export const SET_STANDINGS_LEADERBOARD_DATA = 'SET_STANDINGS_LEADERBOARD_DATA';
export const SHOW_LOADING_SPINNER = 'SHOW_LOADING_SPINNER';

// Action Creator
const mdiStandingsActionCreator = {
  setStandingsLeaderboardData(data: any) {
    return {
      type: SET_STANDINGS_LEADERBOARD_DATA,
      payload: data
    };
  },

  showLoadingSpinner(show: boolean) {
    return {
      type: SHOW_LOADING_SPINNER,
      payload: show
    };
  }
};

export default mdiStandingsActionCreator;
